// Source code from https://googlechrome.github.io/samples/service-worker/post-message/
export function sendServiceWorkerMessage(message: unknown): Promise<void> {
    return new Promise((res, rej) => {
        if(
            typeof navigator === "undefined" ||
            typeof navigator.serviceWorker === "undefined" ||
            !navigator.serviceWorker.controller
        ) {
            rej("Service Workers not supported");

            return;
        }

        const messageChannel = new MessageChannel();

        messageChannel.port1.onmessage = (e): void => {
            if(e.data.error) {
                rej(e.data.error);
            } else {
                res(e.data);
            }
        };

        navigator.serviceWorker.controller.postMessage(message, [ messageChannel.port2 ]);
    });
}
